export const validFiltersNumber = (param) => {
  if (typeof param === 'number') {
    return Number.isInteger(param) && param >= 0;
  } if (typeof param === 'string') {
    return /^(0|([1-9]\d*))$/.test(param);
  }
  return false;
};
